import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export function TanstackDevtools() {
  return (
    <div className="tailwind-root contents ">
      {/* clears the sidebar foot: the Help & Support footer and the dev-origin branch badge above it */}
      <div className="[&_.tsqd-open-btn-container]:bottom-28! [&_.tsqd-open-btn-container]:scale-75!">
        <ReactQueryDevtools buttonPosition="bottom-left" />
      </div>
    </div>
  );
}
